// https://github.com/yuehu/word-count/blob/938cb4be3632159c67c823bf3a42d0366c58b2bf/index.js#L9
const WordRegex = () =>
    /[a-zA-Z0-9_\u0392-\u03c9\u00c0-\u00ff\u0600-\u06ff]+|[\u4e00-\u9fff\u3400-\u4dbf\uf900-\ufaff\u3040-\u309f\uac00-\ud7af]+/g;

/*
 * Split a string around each word, and each other group of non-word character.
 * CJK characters are considered individual words.
 */
export function splitWords(text: string): string[] {
    const wordRegex = WordRegex();

    const splitIndexes = [0];
    let match = wordRegex.exec(text);
    while (match) {
        const word = match[0];
        if (word.charCodeAt(0) >= 0x4e00) {
            // We have a group of CJK characters. Each one are words
            for (let i = match.index; i < match.index + word.length; i += 1) {
                splitIndexes.push(i);
            }
        } else {
            splitIndexes.push(match.index);
            splitIndexes.push(match.index + word.length);
        }
        match = wordRegex.exec(text);
    }
    splitIndexes.push(text.length);

    const words: string[] = [];
    for (let i = 0; i < splitIndexes.length - 1; i += 1) {
        const start = splitIndexes[i];
        const end = splitIndexes[i + 1];
        if (start !== end) {
            const word = text.slice(start, end);
            words.push(word);
        }
    }

    return words;
}
